var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirport03 = function SvgAirport03(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "airport-03_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#airport-03_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.827 16.953h-.001l.002.002-.001-.002Zm.631-.632-.631.631-1.423-2.384-2.387-1.424.631-.633c.08-.08.2-.12.31-.09l1.736.391 2.718-2.938-4.051-2.868.711-.712a.738.738 0 0 1 .813-.15l4.242 1.855 1.494-1.615a3.128 3.128 0 0 1 2.597-.973c.18.02.32.16.34.34.101.963-.26 1.927-.982 2.588L14.96 9.833l1.865 4.251a.734.734 0 0 1-.15.813l-.711.711-2.868-4.05-2.94 2.717.392 1.735c.03.11-.01.23-.09.311Zm-4.444 2.321h11.972v.6H6.014v-.6Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "airport-03_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgAirport03 as ReactComponent };